import { LiveSourceTypes } from '@/enum/liveSourceTypes';

export const isSourceTypeValid = (sourceType: string): boolean => sourceType in LiveSourceTypes;

export const getZoomURL = (
  zoomId: string | undefined,
  params: { userName: string; email: string },
): string => {
  const [meetingId, qs] = zoomId?.split('?') || [];

  const meetingUrl = process.env.VUE_APP_ZOOM_URL?.replace('{MEETING_ID}', meetingId)
    .replace('{USER_NAME}', encodeURI(params.userName))
    .replace('{EMAIL}', encodeURI(params.email));

  return `${meetingUrl}${qs ? `&${qs}` : ''}`;
};
